module.exports = __webpack_public_path__ + "assets/img/17_1039.036e6383.jpg";